export const brandRequest = ({
    name,
    description,
    active
} = {}) => ({
    name,
    description,
    active
})